import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=ff4bee0e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff4bee0e')) {
      api.createRecord('ff4bee0e', component.options)
    } else {
      api.reload('ff4bee0e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=ff4bee0e&", function () {
      api.rerender('ff4bee0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BYkyZ1tX9mmR/JS/comp/ErrorMessage.vue"
export default component.exports